import { createSlice } from '@reduxjs/toolkit';
// import { validateNationalIdNumberFormat } from '../../library/national-id';

const initialState = {
  isLoggedIn: false,
  jwt: null,
  login: {},
  user: {
    _id: undefined,
    fullName: undefined,
    picture: undefined,
  },
  loading: false,
  error: false,
  errorMessage: '',
  registerSuccess: false,
  resetPasswordSent: false,
  changePasswordDone: false,
  emailConfirmed: false,
  recaptchaTokenValidated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading(state, action) {
      const { isLoading, willClearError } = action.payload;

      if (willClearError) {
        state.error = false;
        state.errorMessage = '';
      }
      state.loading = isLoading;
    },
    setError(state, action) {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.payload;
    },
    clearError(state, action) {
      state.error = action.payload;
      state.errorMessage = '';
    },
    login(state, action) {
      state.isLoggedIn = true;
      if (action?.payload?.userLoginData)
        state.login = action.payload.userLoginData;
      if (action?.payload?.userInfoData)
        state.user = action.payload.userInfoData;
      state.error = false;
      state.errorMessage = '';
      state.loading = false;
    },
    updateUser(state, action) {
      const storedUserInfo = localStorage.getItem('userinfo');
      const userInfoData = JSON.parse(storedUserInfo);
      const savedRole = userInfoData?.role
      const finalUserUpdate = {
        ...userInfoData,
        ...action.payload,
        role: savedRole //put back the role
      };
      state.user = finalUserUpdate
      state.error = false;
      state.errorMessage = '';
      state.loading = false;
    },
    setConfirmedEmail(state) {
      state.emailConfirmed = true;
      state.error = false;
      state.errorMessage = '';
      state.loading = false;
    },
    clearConfirmedEmail(state) {
      state.emailConfirmed = false;
    },
    setResetPasswordSent(state, action) {
      state.resetPasswordSent = true;
      state.error = false;
      state.errorMessage = '';
      state.loading = false;
    },
    clearResetPasswordSent(state, action) {
      state.resetPasswordSent = false;
    },
    setChangePasswordDone(state, action) {
      state.changePasswordDone = true;
      state.error = false;
      state.errorMessage = '';
      state.loading = false;
    },
    clearChangePasswordDone(state, action) {
      state.changePasswordDone = false;
    },
    setRecaptchaTokenValidated(state, action) {
      state.recaptchaTokenValidated = true;
    },
    clearRecaptchaTokenValidated(state, action) {
      state.recaptchaTokenValidated = false;
    },
    logout: (state) => initialState,
  },
});

export const authActions = authSlice.actions;
export default authSlice;
